var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-divider',[_vm._v("我是有底线哒")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }